import Column from '@components/column'
import { Fragment } from 'react'
import Fields from '@components/fields'
import CardHeading from '@commons/headings/card'
import {
  StyleReportItem,
  StyleReportItemRemoveWrapper,
  StyleReportRowWrapper,
  StyleConsultItem,
  StyleConsultWrapper,
} from './style'
import Image from '@components/image'
import Svg from '@components/svg'
import Accordion from '@components/accordion'
const Consultation = ({ values, setFieldValue }: any) => {
  return (
    <Column rowGap={20}>
      <Column
        rowGap={20}
        bg="white"
        styleColumn="padding:10px;border-radius:8px;"
      >
        <CardHeading title="Upload Consultation Report" tc="primary" />
        <StyleReportRowWrapper
          onClick={(event: any) => {
            const target = event.target as HTMLElement
            const cross = target.closest('[data-cross-index]')
            if (!!cross) {
              const index: any = cross.getAttribute('data-cross-index')
              if (index >= 0) {
                setFieldValue(
                  'reports',
                  values?.reports?.filter((_, i: number) => i != index),
                )
              }
            }
          }}
        >
          <Fields.Upload
            name={`report`}
            varient="drag"
            size={80}
            styleWrapper="width:80px;"
            onChange={(file) => {
              setFieldValue('reports', [...(values?.reports || []), file])
            }}
          />
          {values?.reports?.map((report, index) => {
            const extension =
              typeof report == 'string'
                ? report.split('.').pop()
                : report?.extension
            const fileUrl =
              typeof report == 'string'
                ? `${process.env.BUCKET_ULR}/${report}`
                : `${report?.info},${report?.base64}`
            return (
              <Fragment key={index}>
                <StyleReportItem>
                  {extension == 'pdf' ? <></> : <Image src={fileUrl} />}
                  <StyleReportItemRemoveWrapper data-cross-index={index}>
                    <Svg svg="cross" color={'white'} size={14} />
                  </StyleReportItemRemoveWrapper>
                </StyleReportItem>
              </Fragment>
            )
          })}
        </StyleReportRowWrapper>
      </Column>
      <Accordion
        items={[
          {
            title: 'Issues',
            renderComponent: () => {
              return (
                <StyleConsultWrapper>
                  {values?.issues?.map((_, index) => {
                    return (
                      <Fragment key={index}>
                        <StyleConsultItem>
                          <Fields.Input
                            name={`issues[${index}]`}
                            placeholder="Enter issues"
                            styleInput="
                                      border:0px;
                                    "
                            onChange={(text) => {
                              setFieldValue(`issues[${index}]`, text)
                              if (index != 0) {
                                if (!text) {
                                  setFieldValue(
                                    'issues',
                                    values?.issues?.filter(
                                      (_, i) => i != index,
                                    ),
                                  )
                                }
                              }
                            }}
                            onKeyDown={(e: any) => {
                              if (e.key == 'Enter') {
                                e.preventDefault()
                                setFieldValue('issues', [...values?.issues, ''])
                              }
                            }}
                          />
                        </StyleConsultItem>
                      </Fragment>
                    )
                  })}
                </StyleConsultWrapper>
              )
            },
          },
          {
            title: 'Examination',
            renderComponent: () => {
              return (
                <StyleConsultWrapper>
                  {values?.examinations?.map((_, index) => {
                    return (
                      <Fragment key={index}>
                        <StyleConsultItem>
                          <Fields.Input
                            name={`examinations[${index}]`}
                            placeholder="Enter examination"
                            styleInput="
                                border:0px;
                              "
                            onChange={(text) => {
                              setFieldValue(`examinations[${index}]`, text)
                              if (index != 0) {
                                if (!text) {
                                  setFieldValue(
                                    'examinations',
                                    values?.examinations?.filter(
                                      (_, i) => i != index,
                                    ),
                                  )
                                }
                              }
                            }}
                            onKeyDown={(e: any) => {
                              if (e.key == 'Enter') {
                                e.preventDefault()
                                setFieldValue('examinations', [
                                  ...values?.examinations,
                                  '',
                                ])
                              }
                            }}
                          />
                        </StyleConsultItem>
                      </Fragment>
                    )
                  })}
                </StyleConsultWrapper>
              )
            },
          },
          {
            title: 'Investigation',
            renderComponent: () => {
              return (
                <StyleConsultWrapper>
                  {values?.investigations?.map((_, index) => {
                    return (
                      <Fragment key={index}>
                        <StyleConsultItem>
                          <Fields.Input
                            name={`investigations[${index}]`}
                            placeholder="Enter Investigation"
                            styleInput="
                                    border:0px;
                                  "
                            onChange={(text) => {
                              setFieldValue(`investigations[${index}]`, text)
                              if (index != 0) {
                                if (!text) {
                                  setFieldValue(
                                    'investigations',
                                    values?.investigations?.filter(
                                      (_, i) => i != index,
                                    ),
                                  )
                                }
                              }
                            }}
                            onKeyDown={(e: any) => {
                              if (e.key == 'Enter') {
                                e.preventDefault()
                                setFieldValue('investigations', [
                                  ...values?.investigations,
                                  '',
                                ])
                              }
                            }}
                          />
                        </StyleConsultItem>
                      </Fragment>
                    )
                  })}
                </StyleConsultWrapper>
              )
            },
          },
          {
            title: 'Treatment',
            renderComponent: () => {
              return (
                <StyleConsultWrapper>
                  {values?.treatments?.map((_, index) => {
                    return (
                      <Fragment key={index}>
                        <StyleConsultItem>
                          <Fields.Input
                            name={`treatments[${index}]`}
                            placeholder="Enter treatment"
                            styleInput="
                                    border:0px;
                                  "
                            onChange={(text) => {
                              setFieldValue(`treatments[${index}]`, text)
                              if (index != 0) {
                                if (!text) {
                                  setFieldValue(
                                    'treatments',
                                    values?.treatments?.filter(
                                      (_, i) => i != index,
                                    ),
                                  )
                                }
                              }
                            }}
                            onKeyDown={(e: any) => {
                              if (e.key == 'Enter') {
                                e.preventDefault()
                                setFieldValue('treatments', [
                                  ...values?.treatments,
                                  '',
                                ])
                              }
                            }}
                          />
                        </StyleConsultItem>
                      </Fragment>
                    )
                  })}
                </StyleConsultWrapper>
              )
            },
          },
        ]}
        titleAsKey="title"
      />
    </Column>
  )
}

export default Consultation
